export default {
    title: 'dark',

    colors: {
        primary: '#333',
        secundary: '#35FF69',

        background: '#222',
        text: '#fff'
    },

};